import React, { useEffect } from 'react';

interface PdfViewerModalProps {
  fileUrl: string;
  onClose: () => void;
}

const PdfViewerModal: React.FC<PdfViewerModalProps> = ({ fileUrl, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { 
      document.body.style.overflow = ''; 
    };
  }, []);

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div 
      style={{ marginTop: "90px" }} 
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="relative bg-white rounded-lg shadow-lg w-full max-w-4xl h-[75vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute btn-azul top-3 right-3 p-2 z-50 rounded flex items-center justify-center"
          aria-label="Cerrar modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z" />
          </svg>
        </button>

        <div className="flex-grow overflow-hidden rounded-lg">
          <object
            data={fileUrl}
            type="application/pdf"
            className="w-full h-full border-0 rounded-lg"
          >
            {/* Fallback si object no funciona */}
            <div className="p-4 text-center">
              <p className="mb-4 text-gray-600">
                No se puede mostrar el PDF en tu navegador.
              </p>
              <a 
                href={fileUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-azul inline-block px-4 py-2 rounded"
              >
                Abrir PDF en nueva pestaña
              </a>
            </div>
          </object>
        </div>
      </div>
    </div>
  );
};

export default PdfViewerModal;